export default "__VITE_ASSET__DmS7wuVd__"